module.exports = __webpack_public_path__ + "img/tips3list3img19122401.6de5a32e.jpg";